/* v80: step labels before a path is chosen ("Bikes", "Dates" instead of "…"). Loads after yb-1..4. */
(function(){
  if (typeof stepper !== 'function' || typeof S === 'undefined') return;
  var orig = stepper;
  stepper = function(){
    if (S.flow) return orig.apply(this, arguments);
    var el = document.getElementById('yb-stepper'); if (!el) return;
    el.innerHTML = ['Demo or hire','Bikes','Dates','Your details'].map(function(l,i){
      return '<div class="yb-step'+(i===S.step?' on':'')+'"><span class="n">'+(i+1)+'</span>'+l+'</div>';
    }).join('');
  };
  try { var el = document.getElementById('yb-stepper'); if (!S.flow && el && el.innerHTML) stepper(); } catch(e){}
})();

/* v83: open straight on a path when the section says so (demo page = bikes first, hire page = dates first).
   A link's own ?type= or an assistant ?hold= still wins. yb-3 renders once the day rules load, after this runs. */
(function(){
  var root = document.getElementById('yeti-booking');
  if (!root || typeof S === 'undefined') return;
  var f = root.getAttribute('data-start-flow');
  var q = new URLSearchParams(location.search);
  if (q.get('hold') || q.get('type')) return;
  if (f !== 'demo' && f !== 'hire') return;
  S.flow = f; S.step = 1;
  try { stepper(); } catch(e){}
  /* if the day rules already loaded and the chooser rendered, redraw on the chosen path */
  try { if (!document.querySelector('#yb-view .yb-msg')) render(); } catch(e){}
})();

/* v84: bike photos on the booking list. Each row gets a thumbnail (from the section's "Bike photo" blocks,
   matched on the model name); tap it to see the photo big. Rows are redrawn often, so a MutationObserver re-adds them. */
(function(){
  var data = document.getElementById('yb-photos'), view = document.getElementById('yb-view');
  if (!data || !view) return;
  var P = {};
  try { JSON.parse(data.textContent).forEach(function(p){ if (p && p.m && p.t) P[String(p.m).trim().toLowerCase()] = p; }); } catch(e){ return; }
  function attr(s){ return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); }
  function open(src, name){
    var o = document.createElement('div');
    o.className = 'yb-lightbox'; o.setAttribute('role','dialog'); o.setAttribute('aria-label', name);
    o.innerHTML = '<img src="'+attr(src)+'" alt="'+attr(name)+'"><button type="button" aria-label="Close">&times;</button>';
    function close(){ o.remove(); document.removeEventListener('keydown', key); }
    function key(e){ if (e.key === 'Escape') close(); }
    o.addEventListener('click', close);
    document.addEventListener('keydown', key);
    document.body.appendChild(o);
  }
  function decorate(){
    [].forEach.call(view.querySelectorAll('.yb-model'), function(row){
      if (row.querySelector('.yb-thumb')) return;
      var h = row.querySelector('h3'); if (!h) return;
      var name = h.textContent.trim(), p = P[name.toLowerCase()]; if (!p) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'yb-thumb'; b.setAttribute('aria-label', 'See a bigger photo of the ' + name);
      b.innerHTML = '<img src="'+attr(p.t)+'" alt="Yeti '+attr(name)+'" loading="lazy">';
      b.addEventListener('click', function(){ open(p.f || p.t, 'Yeti ' + name); });
      row.insertBefore(b, row.firstChild);
      row.classList.add('has-thumb');
    });
  }
  new MutationObserver(decorate).observe(view, { childList: true, subtree: true });
  decorate();
})();

/* v84: on the demo and hire pages the path is already chosen, so the steps drop "Demo or hire":
   demo = Choose bikes · Pick dates · Your details; hire = Pick dates · Choose bikes · Your details.
   Going "back" past the first step returns to the page's own first step (never the demo/hire chooser),
   and the first step has no Back button. */
(function(){
  var root = document.getElementById('yeti-booking');
  if (!root || typeof S === 'undefined') return;
  var f = root.getAttribute('data-start-flow');
  if (f !== 'demo' && f !== 'hire') return;
  if (new URLSearchParams(location.search).get('hold')) return;
  var LAB = { demo:['Choose bikes','Pick dates','Your details'], hire:['Pick dates','Choose bikes','Your details'], slot:['Pick a time','Choose a bike','Your details'] };
  var prevStepper = stepper;
  stepper = function(){
    if (!S.flow || !LAB[S.flow] || S.step < 1) return prevStepper.apply(this, arguments);
    var el = document.getElementById('yb-stepper'); if (!el) return;
    el.innerHTML = LAB[S.flow].map(function(l,i){
      return '<div class="yb-step'+(i === S.step-1 ? ' on' : '')+'"><span class="n">'+(i+1)+'</span>'+l+'</div>';
    }).join('');
  };
  var prevGo = go;
  go = function(n){
    if (n <= 0) { S.flow = f; S.cart = []; S.start = S.end = null; S.slot = null; S.slotDay = null; n = 1; }
    return prevGo(n);
  };
  var prevRender = render;
  render = function(){
    var r = prevRender.apply(this, arguments);
    if (S.flow === f && S.step === 1) { var b = document.getElementById('yb-back'); if (b) b.style.display = 'none'; }
    return r;
  };
  try { stepper(); } catch(e){}
})();

/* v84: TQ range extender add-on, hire flow only. The Hub's /availability sends
   `extender` {offered, available, day_cents}; /hold takes `extender: true`. */
(function(){
  if (typeof S === 'undefined' || typeof api !== 'function') return;
  S.extender = false; S.ext = null;
  var st = document.createElement('style');
  st.textContent = '#yeti-booking .yb-ext{display:flex;gap:10px;align-items:flex-start;margin:12px 0 6px;padding:12px;border:1px solid rgba(0,0,0,.14);border-radius:10px;cursor:pointer;background:#fff}'+
    '#yeti-booking .yb-ext input{margin-top:3px;width:18px;height:18px;flex:none}'+
    '#yeti-booking .yb-ext b{display:block;font-size:14px}'+
    '#yeti-booking .yb-ext small{display:block;font-size:13px;line-height:1.4;opacity:.75;margin-top:3px}'+
    '#yeti-booking .yb-ext.off{cursor:default;opacity:.6}';
  document.head.appendChild(st);
  function hasE(){ return S.flow === 'hire' && S.cart.some(isE); }
  function dayC(){ return (S.ext && S.ext.day_cents) || 2000; }
  function extOn(){ return hasE() && S.extender === true && !!(S.ext && S.ext.available) && days() > 0; }
  var prevApi = api;
  api = function(path, opts){
    var p = String(path);
    if (p.indexOf('/hold') === 0 && opts && opts.method === 'POST' && S.flow === 'hire') {
      try { var b = JSON.parse(opts.body); if (b.type === 'hire') { b.extender = extOn(); opts = Object.assign({}, opts, { body: JSON.stringify(b) }); } } catch(e){}
    }
    var r = prevApi(path, opts);
    if (p.indexOf('/availability?type=hire') === 0) {
      r = r.then(function(j){
        S.ext = j.extender || null;
        if (!(S.ext && S.ext.available)) S.extender = false;
        setTimeout(function(){ if (S.flow === 'hire') drawCart(); }, 0);
        return j;
      });
    }
    return r;
  };
  var prevCharge = chargeCents;
  chargeCents = function(){ var c = prevCharge.apply(this, arguments); return c ? c + (extOn() ? dayC() * days() : 0) : c; };
  var prevDraw = drawCart;
  drawCart = function(){
    if (!hasE()) S.extender = false;
    var r = prevDraw.apply(this, arguments);
    var ex = S.ext;
    if (!hasE() || !ex || !ex.offered) return r;
    var cart = document.querySelector('#yb-cartwrap .yb-cart'); if (!cart) return r;
    var d = days(), html = '';
    if (extOn()) html += '<div class="yb-ci"><span>Range extender · '+money(dayC())+' × '+d+(d === 1 ? ' day' : ' days')+'</span><span class="yb-cip">'+money(dayC()*d)+'</span></div>';
    if (S.step !== 3) html += '<label class="yb-ext'+(ex.available ? '' : ' off')+'"><input type="checkbox" id="yb-extck"'+(extOn() ? ' checked' : '')+(ex.available ? '' : ' disabled')+'>'+
      '<span><b>Add a TQ range extender · +'+money(dayC())+' a day</b><small>'+(ex.available ? 'Clips onto the frame and adds range for the big days. Comes out with the bike, back with the bike.' : 'Already out on those dates')+'</small></span></label>';
    if (!html) return r;
    var box = document.createElement('div'); box.innerHTML = html;
    var at = cart.querySelector('.yb-tot') || cart.querySelector('#yb-cont');
    while (box.firstChild) cart.insertBefore(box.firstChild, at || null);
    var ck = cart.querySelector('#yb-extck');
    if (ck) ck.onchange = function(){ S.extender = ck.checked; drawCart(); };
    return r;
  };
  var prevGo2 = go;
  go = function(n){ if (n <= 0) S.extender = false; return prevGo2(n); };
})();

/* v84: hire page — short demos days (half-day slot days) are reserved for demoing and can't be hired.
   They're blocked on the calendar, the key says so, and the "See available bikes" button only shows once dates are picked. */
(function(){
  var root = document.getElementById('yeti-booking');
  if (!root || root.getAttribute('data-start-flow') !== 'hire' || typeof month !== 'function' || typeof rDates !== 'function') return;
  var st = document.createElement('style');
  st.textContent = '#yeti-booking .yb-day.reserved{cursor:not-allowed;color:var(--yb-mut,#8a949c);text-decoration:line-through;opacity:.55}'+
    '#yeti-booking #yb-next:disabled{display:none}'+
    '#yeti-booking .yb-reserved-note{margin:10px 0 0;font-size:13px;color:var(--yb-mut,#5f6b73)}';
  document.head.appendChild(st);
  var prevMonth = month;
  month = function(){
    var el = prevMonth.apply(this, arguments);
    if (S.flow !== 'hire') return el;
    [].forEach.call(el.querySelectorAll('.yb-day.slot'), function(c){
      c.classList.add('reserved'); c.onclick = null;
      var r = rule(c.dataset.d);
      c.title = 'Reserved for demo days' + (r && r.label ? ' · ' + r.label : '');
    });
    return el;
  };
  var prevDates = rDates;
  rDates = function(){
    var out = prevDates.apply(this, arguments);
    if (S.flow !== 'hire') return out;
    var key = document.querySelector('#yb-view .yb-key');
    if (key) key.innerHTML = key.innerHTML.replace('short demos day', 'reserved for demo days');
    var cal = document.getElementById('yb-cal');
    if (cal && cal.querySelector('.yb-day.reserved') && !document.querySelector('.yb-reserved-note')) {
      var p = document.createElement('p'); p.className = 'yb-reserved-note';
      p.textContent = 'Crossed-out days are reserved for demoing (busy weekends and events), so they can’t be booked for hire.';
      cal.insertAdjacentElement('afterend', p);
    }
    var w = document.getElementById('yb-toslot');
    if (w) {
      var rd = rangeDays().filter(function(d){ return rule(d) && rule(d).mode === 'slots'; });
      w.closest('.yb-warn').innerHTML = rd.map(fmt).join(', ') + (rd.length > 1 ? ' are' : ' is') + ' reserved for demoing, so a hire can’t include ' + (rd.length > 1 ? 'them' : 'it') + '. Pick dates either side.';
    }
    return out;
  };
})();
